import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import localeUk from '@angular/common/locales/uk';
import localeRu from '@angular/common/locales/ru';
import localeDe from '@angular/common/locales/de';
import localePl from '@angular/common/locales/pl';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeUk, 'uk');
registerLocaleData(localeRu, 'ru');
registerLocaleData(localeDe, 'de');
registerLocaleData(localePl, 'pl');

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
